module.exports = __webpack_public_path__ + "img/ic_baby_humidity.f666b249.png";